import { BUILDINGS, type BuildingId, UNITS, type UnitId } from "./content/buildings.js";
import { FIXED_STRUCTURES } from "./content/setup.js";

export function buildingRule(id: BuildingId): (typeof BUILDINGS)[number] {
  const value = BUILDINGS.find((candidate) => candidate.id === id);
  if (!value) throw new TypeError(`Missing building rule: ${id}`);
  return value;
}

export function outputRule(
  producerId: BuildingId,
  quantity: string,
): (typeof BUILDINGS)[number]["outputs"][number] {
  const value = buildingRule(producerId).outputs.find((output) => output.quantity === quantity);
  if (!value) throw new TypeError(`Missing ${quantity} output for ${producerId}`);
  return value;
}

export function unitRule(id: UnitId): (typeof UNITS)[number] {
  const value = UNITS.find((candidate) => candidate.id === id);
  if (!value) throw new TypeError(`Missing unit rule: ${id}`);
  return value;
}

export const EMERGENCY_WORKSHOP = FIXED_STRUCTURES[1];
export const HEADQUARTERS = FIXED_STRUCTURES[0];
export const GUARD_ROBOT = UNITS[0];
